import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';

const CandidateNotesScreen = () => {
  return <SimeraDashboard page={InternalDashboardPages.NOTES} />;
};

export default CandidateNotesScreen;
